import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { isMobile } from "../../../utils";
import SVGInline from "react-svg-inline";
import { clientMedia } from "../../../Config/Settings";
import arrowSideSVG from "../../inlineSVGs/arrowSideSVG";

import './SelectionSlider.css';

class SelectionSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCat: ''
        };

        this.itemsScrollerRef = null;
    }

    componentDidMount() {
        this.scrollAnim();

        this.setState({ selectedCat: this.props.filters.category });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filters && this.props.filters) {
            if (prevProps.filters.category !== this.props.filters.category) {
                this.setState({ selectedCat: this.props.filters.category })
            }
        }
    }

    scrollAnim() {
        if (this.itemsScrollerRef && this.props.scrollAnimDis) {

            this.itemsScrollerRef.scrollLeft = this.props.scrollAnimDis;

            setTimeout(() => {
                if (!this.itemsScrollerRef) return;

                this.itemsScrollerRef.scrollBy({
                    top: 0,
                    left: this.props.scrollAnimDis * -1,
                    behavior: 'smooth'
                })
            }, 1400)
        }
    }

    scrollSubCat(side) {
        if (!this.itemsScrollerRef) return;

        if (side === 'left') {
            this.itemsScrollerRef.scrollBy({
                top: 0,
                left: this.props.scrollAnimDis * -1,
                behavior: 'smooth'
            });

            return;
        }

        if (side === 'right') {
            this.itemsScrollerRef.scrollBy({
                top: 0,
                left: 300,
                behavior: 'smooth'
            });
        }
    }

    handleCatClick(category) {
        this.setState({ selectedCat: this.state.selectedCat === category.name ? '' : category.name});

        this.props.handleClickItem(category.name);

        setTimeout(() => {
            if (this.props.filters.category !== this.state.selectedCat) {
                this.setState({ selectedCat: this.props.filters.category })
            }
        }, 500)
    }

    renderSubCategories() {
        if (!this.props.datatypes || !this.props.datatypes.subCategories || !this.props.datatypes.subCategories) return null;

        const subCatIndex = this.props.filters.category || (this.props.filters.type === 'liveMusic' ? 'openmic' : 'musicteachers');

        return (
            this.props.datatypes.subCategories[subCatIndex].map((subCategory, index) => {
                return (
                    <div key={index}
                         className={`subCategory ${this.props.filters.type} ${this.props.filters.subCategory === subCategory ? 'selected' : 'unselected'}`}
                         onClick={()=> this.props.handleClickItem(subCategory)}>
                        {subCategory}
                    </div>
                )
            })
        )
    }

    renderCategories() {
        if (!this.props.datatypes || !this.props.datatypes.categories) return null;

        return this.props.datatypes.categories[this.props.filters.type].map((category, index)=> {
            if (category.isHidden) return null;

            return (
                <div key={index} className={"category " + this.props.filters.type}
                     onClick={() => this.handleCatClick(category)}>
                    <div className="icon-wrapper">
                        <div className={"icon selected"}
                             style={{
                                 visibility: category.name === this.state.selectedCat ? "visible" : "hidden",
                                 backgroundImage: `url(${clientMedia()}/img/categoriesNeon/${category.name}.svg)`
                             }}>
                        </div>
                        <div className={"icon noHover"}
                             style={{
                                 visibility: category.name === this.state.selectedCat ? "hidden" : "visible",
                                 backgroundImage: `url(${clientMedia()}/img/categories/${category.name}.svg)`
                             }}>
                        </div>
                        <div className={"icon hover"}
                             style={{
                                 visibility: category.name === this.state.selectedCat ? "hidden" : "visible",
                                 backgroundImage: `url(${clientMedia()}/img/categoriesHover/${category.name}.svg)`
                             }}>
                        </div>
                    </div>
                    <div className="categoryText">
                        {category.text}
                    </div>
                </div>
            )
        })
    }

    renderItems() {
        if (this.props.sliderType === 'subCategories') return this.renderSubCategories();
        if (this.props.sliderType === 'categories') return this.renderCategories();

        return null;
    }

    renderArrows() {
        return [
            <div
                key="arrow-slider-0"
                className={`subcategories-left-arrow ${this.props.filters.type} ${isMobile() ? 'mobile' : ''}`}
                onClick={() => this.scrollSubCat('left')}
            >
                <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
            </div>,
            <div
                key="arrow-slider-1"
                className={`subcategories-right-arrow ${this.props.filters.type} ${isMobile() ? 'mobile' : ''}`}
                onClick={() => this.scrollSubCat('right')}
            >
                <SVGInline className="arrow-side-icon" svg={arrowSideSVG} component="i"/>
            </div>
        ]
    }

    render() {
        if (!this.props || !this.props.filters || !this.props.datatypes) return null;

        return (
            <div className="selection-slider-wrapper">
                {this.props.sliderType === 'subCategories' ? this.renderArrows() : null}

                <div className="scroller rtl" ref={ref => {
                    this.itemsScrollerRef = ref
                }}>
                    {this.renderItems()}
                </div>
            </div>
        )
    }
}

SelectionSlider.propTypes = {
    sliderType: PropTypes.string,
    datatypes: PropTypes.object,
    filters: PropTypes.object,
    handleClickItem: PropTypes.func,
    scrollAnimDis: PropTypes.number
};

export default SelectionSlider;



// WEBPACK FOOTER //
// ./src/Components/Elements/Carousels/SelectionSlider.js